export default {
  // Page metadata
  'meta.title': 'Masharti ya Huduma - timer.today',
  'meta.description': 'Masharti ya Huduma na makubaliano ya matumizi ya jukwaa la zana za kipima muda mtandaoni timer.today. Jifunze kuhusu sheria za huduma yetu, haki na majukumu ya watumiaji.',

  // Page header
  'page.title': 'Masharti ya Huduma',
  'page.lastUpdated': 'Imeboreshwa mwisho: {{date}}',
  'page.intro': 'Karibu kwenye timer.today. Masharti na hali hizi yanafafanua sheria na kanuni za matumizi ya tovuti ya timer.today, iliyopo kwenye timer.today.',

  // Section 1
  'section1.title': '1. Kukubali Masharti',
  'section1.content': 'Kwa kufikia na kutumia tovuti hii, unakubali na kukubaliana kufungwa na masharti na masharti ya makubaliano haya. Ikiwa hukubaliani kuzingatia yaliyotajwa hapo juu, tafadhali usitumie huduma hii.',

  // Section 2
  'section2.title': '2. Maelezo ya Huduma',
  'section2.intro': 'timer.today hutoa zana za kipima muda za bure mtandaoni ikiwa ni pamoja na:',
  'section2.timer': 'Kipima Muda cha Kuhesabu Nyuma - Kipima muda kinachoweza kubadilishwa kwa uzalishaji, upishi na usimamizi wa muda',
  'section2.stopwatch': 'Saa ya Kusimamisha - Chombo cha kipima muda cha usahihi wa juu kwa michezo, mafunzo na kipimo sahihi cha muda',
  'section2.worldclock': 'Saa ya Dunia - Onyesho la wakati halisi wa maeneo ya saa ya kimataifa',

  // Section 3
  'section3.title': '3. Leseni ya Matumizi',
  'section3.intro': 'Ruhusa inatolewa kutumia timer.today kwa muda kwa matazamo ya kibinafsi, yasiyo ya kibiashara pekee. Hii ni leseni ya kutoa, si uhamishaji wa cheo, na chini ya leseni hii huwezi:',
  'section3.item1': 'Kubadilisha au kunakili nyenzo',
  'section3.item2': 'Kutumia nyenzo kwa madhumuni yoyote ya kibiashara au kwa onyesho lolote la umma',
  'section3.item3': 'Kujaribu kufanya uhandisi wa nyuma wa programu yoyote iliyomo kwenye tovuti',
  'section3.item4': 'Kuondoa hakimiliki yoyote au arifa zingine za umiliki kutoka kwa nyenzo',

  // Section 4
  'section4.title': '4. Faragha na Data',
  'section4.intro': 'timer.today imejitolea kulinda faragha yako:',
  'section4.item1': 'Hatukusanyi au kuhifadhi taarifa za kibinafsi',
  'section4.item2': 'Mipangilio ya kipima muda inahifadhiwa kimtaa kwenye kivinjari chako',
  'section4.item3': 'Hatufuatilii tabia ya mtumiaji au mifumo ya matumizi',
  'section4.item4': 'Hakuna vidakuzi vinavyotumiwa kwa madhumuni ya ufuatiliaji',

  // Section 5
  'section5.title': '5. Kukataa',
  'section5.content': 'Nyenzo zilizo kwenye timer.today zinapatikana kwa msingi wa \'kama ilivyo\'. timer.today haitoi dhamana yoyote, iliyoelezwa au isiyo ya wazi, na kwa hii inakataa na kuondoa dhamana zote zingine ikiwa ni pamoja na bila kikomo, dhamana zisizo wazi au masharti ya uuzaji, ufaao kwa madhumuni fulani, au kutovunja mali ya kiakili au uvunjaji mwingine wa haki.',

  // Section 6
  'section6.title': '6. Mipaka',
  'section6.content': 'Katika tukio lolote timer.today au wasambazaji wake hawatawajibika kwa uharibifu wowote (ikiwa ni pamoja na, bila kikomo, uharibifu kwa kupoteza data au faida, au kutokana na kukatizwa kwa biashara) unaoibuka kutokana na matumizi au kutoweza kutumia nyenzo zilizo kwenye timer.today, hata ikiwa timer.today au mwakilishi wake aliyeidhinishwa amefahamishwa kwa mdomo au kwa maandishi kuhusu uwezekano wa uharibifu kama huo.',

  // Section 7
  'section7.title': '7. Usahihi wa Nyenzo',
  'section7.content': 'Nyenzo zinazoonekana kwenye timer.today zinaweza kujumuisha makosa ya kiufundi, ya uchapishaji au ya picha. timer.today haidhamini kwamba nyenzo zozote zilizo kwenye tovuti yake ni sahihi, kamili au za sasa. timer.today inaweza kufanya mabadiliko kwa nyenzo zilizo kwenye tovuti yake wakati wowote bila taarifa.',

  // Section 8
  'section8.title': '8. Marekebisho',
  'section8.content': 'timer.today inaweza kurekebisha masharti haya ya huduma kwa tovuti yake wakati wowote bila taarifa. Kwa kutumia tovuti hii, unakubaliana kufungwa na toleo la sasa la masharti haya ya huduma.',

  // Section 9
  'section9.title': '9. Maelezo ya Mawasiliano',
  'section9.intro': 'Ikiwa una maswali yoyote kuhusu Masharti haya ya Huduma, tafadhali wasiliana nasi kwenye:',
  'section9.email': 'Barua pepe:',
  'section9.emailSubject': 'Ulizo wa Masharti ya Huduma - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. Haki zote zimehifadhiwa.'
};
